<template>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      viewBox="0 0 24 24"
      :width="width"
      :height="width"
      :fill="svgColor"
    >
      <path
        d="M14.019,4.81c.891-.837,2.284-1.042,3.374-.495l3.371,1.686h3.236v-2h-2.764l-2.948-1.475c-1.824-.913-4.153-.574-5.641,.828l-.618,.582-.7-.638c-.919-.837-2.109-1.298-3.39-1.298-.771,0-1.54,.182-2.227,.525l-2.949,1.475H0v2H3.236l3.372-1.686c1.022-.514,2.458-.375,3.374,.462l.587,.535-2.646,2.492c-1.073,1.072-1.244,2.767-.398,3.938,.52,.723,1.399,1.259,2.444,1.259,.793,0,1.554-.312,2.104-.863l1.006-.963,6.343,4.757-7.422,5.55L3.333,15H0v2H2.667l9.333,6.979,9.333-6.979h2.667v-2h-2.487l-6.97-5.227,1.688-1.616-1.383-1.445-4.173,3.995c-.208,.208-.491,.315-.788,.29-.298-.024-.56-.175-.739-.425-.274-.38-.19-.975,.168-1.334l4.703-4.429Z"
      />
    </svg>
  </template>
  
  <script>
  export default {
    props: {
      svgColor: {
        type: String,
        default: "#000000", // Set a default fill color if not provided
      },
    },
  };
  </script>
  